import { useContext } from "react";
import { FeatureToggleContext } from "./FeatureToggleContext";

// NOTE:
// Only `SURVEY`, `SITE_SETTINGS`, and `UNDER_MAINTENANCE` are permanent.
// Update this enum to toggle additional features in the future.
export enum DISABLED_FEATURES {
  SITE_SETTINGS = "site_settings",
  UNDER_MAINTENANCE = "under_maintenance",
  ADSSO_SITE_RESTRICTION = "adsso_site_restriction",
  PROFILE_AND_GEOIP_PERSIST = "profile_and_geoip_persist",
}

export const useFeatureToggle = () => {
  const { disabledFeatures } = useContext(FeatureToggleContext);
   
  /** Check if a feature is disabled */
  const isDisabled = (featureName: DISABLED_FEATURES) => {
    //WHEN USER IS ON LOCAL ENV, FORCE FEATURE TOGGLE TO RETURN TRUE TO RUN LOCALLY
    return disabledFeatures.includes(featureName);
  };

  return { isDisabled };
};
